export default "__VITE_ASSET__bfb51254__"